/* unplugin-vue-components disabled */import script from "./Layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./Layout.vue?vue&type=script&setup=true&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=637c83dc&lang=scss&scoped=true"
import "./Layout.vue?vue&type=style&index=1&id=637c83dc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637c83dc"]])

export default __exports__